module.exports = __webpack_public_path__ + "media/partners/kraft-083b3bf0.svg";